import axios from 'axios'
import router from '@/router'

export default {
  INITIALIZE({ commit, state }) {
    // LocalStorage token
    const token = localStorage.getItem('token_key')
    if (token) {
      commit('SET_TOKEN', token)
    } else {
      commit('REMOVE_TOKEN')
    }
    // LocalStorage language
    !localStorage.lang
      ? (localStorage.lang = 'ru')
      : commit('SET_LANGUAGE', localStorage.lang)
    // LocalStorage default filters
    if (!localStorage.filters) {
      localStorage.filters = JSON.stringify({ ...state.baseFilters })
    }
  },
  LOGOUT({ commit }) {
    const logout = confirm('Вы действительно хотите выйти')
    if (logout) {
      commit('REMOVE_TOKEN')
      router.push({ path: '/' })
    }
  },
  SEND_PHONE_NUMBER({ commit }, phoneNumber) {
    return axios({
      url: `/api/user/StartAuthorization/${phoneNumber}`,
      method: 'post'
    }).then(response => {
      if (response.data.status === 'success') {
        return response.data.result.sessionId
      } else {
        return false
      }
    })
  },
  CHECK_SMS_CODE({ commit, state }, data) {
    return axios({
      url: `/api/user/CheckSmsCode/${data.sessionId}/${data.code}`,
      method: 'post'
    }).then(response => {
      if (response.data.status === 'success') {
        commit('SET_TOKEN', data.sessionId)
        return true
      } else {
        return false
      }
    })
  },
  GET_USER_INFO({ commit, state, dispatch }) {
    const sessionId = state.token
    return axios({
      url: `/api/user/info/${sessionId}`,
      method: 'get'
    }).then(response => {
      if (response.status === 200) {
        const data = { ...response.data }
        commit('SET_USER_INFO', data)
        if (data.company) commit('SET_USER_COMPANY', data.company)
        if (data.userAdverts.length) {
          dispatch('GET_USER_ADVERTS_LIST', data.userAdverts)
        }
      }
    })
  },
  SET_LANGUAGE({ commit }, lang) {
    localStorage.lang = lang
    commit('SET_LANGUAGE', lang)
  },
  GET_CITY_LIST({ commit }) {
    return axios({
      url: '/api/Text/GetCities/Ru',
      method: 'get'
    })
      .then(response => {
        commit('SET_CITY_LIST', response.data)
      })
      .catch(err => {
        console.error('City list: ', err)
      })
  },
  GET_CURRENCY_LIST({ commit }) {
    axios({
      url: `/api/Text/GetCurrencies/Ru`,
      method: 'get'
    })
      .then(response => {
        if (response.status === 200) {
          commit('SET_CURRENCY_LIST', response.data)
        }
      })
      .catch(err => {
        console.error('GET_CURRENCY_LIST: ', err)
      })
  },
  GET_USER_ADVERTS_LIST({ commit }, advertsIds) {
    return axios({
      url: `/api/Advert/GetAdverts/Ru`,
      method: 'post',
      data: advertsIds
    }).then(response => {
      commit('SET_USER_ADVERTS_LIST', response.data.adverts)
    })
  },
  SET_SKIP_ADVERTS({ commit }, data) {
    commit('SET_SKIP_ADVERTS', data)
  },
  GET_NEW_PROPERTY_LIST({ state, commit }) {
    const filters = JSON.parse(localStorage.filters)
    filters.items.AllComplex = true
    filters.items.JustCount = false
    return axios({
      url: `/api/Advert/Search/${state.language}/${filters.advertType}`,
      method: 'post',
      data: {
        AllComplex: true,
        CityId: 1
      }
    }).then(response => {
      commit('SET_NEW_PROPERTY_LIST', response.data)
    })
  },
  GET_ADVERTS_LIST({ state, commit }, skip = 0, map) {
    commit('GET_ADVERT_LIST_LOADING', true)
    const filters = JSON.parse(localStorage.filters)
    filters.items.JustCount = false
    filters.items.SkipAdverts = skip < 0 ? 0 : skip

    if (skip < 0) {
      filters.items.MaxShowCountAdverts = 10000
    } else {
      filters.items.MaxShowCountAdverts = 25
    }

    if (Number(filters.items.DurationRent) === 0) {
      delete filters.items.DurationRent
    }

    if (filters.items.RoomCount) {
      if (!filters.items.RoomCount.length) {
        delete filters.items.RoomCount
      }
    }

    return axios({
      url: `/api/Advert/Search/${state.language}/${filters.advertType}`,
      method: 'post',
      data: filters.items
    }).then(response => {
      commit('SET_ADVERTS_LIST', response.data.adverts)
      commit('SET_ADVERTS_FOUND_FILTER_COUNT', response.data.foundAdverts)
      commit('GET_ADVERT_LIST_LOADING', false)
    })
  },
  GET_ADVERTS_FILTER_COUNT({ commit }, data = {}) {
    let filters = {}
    if (Object.keys(data).length === 0 && data.constructor === Object) {
      filters = JSON.parse(localStorage.filters)
    } else {
      filters = data
    }
    filters.items.JustCount = true

    if (Number(filters.items.DurationRent) === 0) {
      delete filters.items.DurationRent
    }

    if (filters.items.RoomCount) {
      if (!filters.items.RoomCount.length) {
        delete filters.items.RoomCount
      }
    }
    return axios({
      url: `/api/Advert/Search/Ru/${filters.advertType}`,
      method: 'post',
      data: filters.items
    }).then(response => {
      commit('SET_ADVERTS_FOUND_FILTER_COUNT', response.data.foundAdverts)
    })
  },
  GET_DINAMIC_FILTERS({ commit, state }, type) {
    axios({
      url: `/api/Advert/GetFilters/${state.language}/${type}`,
      method: 'get'
    }).then(response => {
      commit('SET_DINAMIC_FILTERS', response.data.filters)
      commit('SET_RANGE_FILTERS', response.data.rangeFilters)
    })
  },
  GET_ADVERTS_ITEMS({ commit }, type) {
    axios({
      url: `/api/record/GetRecordItems/Ru/${type}`,
      method: 'get'
    }).then(response => {
      commit('SET_ADVERTS_ITEMS', response.data.items)
    })
  },
  GET_DISTRICT_LIST({ commit }, city) {
    return axios({
      url: `/api/Text/GetDistricts/Ru/${city}`,
      method: 'get'
    }).then(response => {
      if (response.status === 200) {
        commit('SET_DISTRICT_LIST', response.data)
      }
    })
  },
  CREATE_ADVERT({ commit, state }, { advertType, payload }) {
    const sessionId = state.token
    return axios({
      method: 'POST',
      url: `/api/Advert/Create/${sessionId}/${advertType}`,
      data: payload
    })
      .then(response => {
        return response.data
      })
      .catch(e => {
        const { data } = e.response
        return { error: true, msg: (data || {}).message }
      })
  },
  EDIT_ADVERT({ commit, state }, { advertType, id, payload }) {
    console.log('data: ', payload)
    const sessionId = state.token
    return axios({
      url: `/api/Advert/edit/${sessionId}/${advertType}/${id}`,
      method: 'post',
      data: payload
    })
      .then(response => {
        return response.data
      })
      .catch(e => {
        const { data } = e.response
        return { error: true, msg: (data || {}).message }
      })
  },
  GET_ADVERT_VIEW_ITEM({ commit, state }, advertId) {
    return axios({
      url: `/api/Record/GetAdvert/${state.language}/${advertId}`,
      method: 'get'
    }).then(response => {
      commit('SET_ADVERT_EDIT_ITEM', response.data)
      return response.data.rent
    })
  },
  DELETE_ADVERT({ commit, state, dispatch }, data) {
    const del = confirm('Вы действительно хотите удалить объявление?')
    if (del) {
      const sessionId = state.token
      return axios({
        url: `/api/Advert/delete/${sessionId}/${data.type}/${data.id}`,
        method: 'post'
      }).then(response => {
        dispatch('GET_USER_INFO')
        return response.data
      })
    }
  },
  GET_ADVERT_ITEM({ commit }, advertId) {
    return axios({
      url: `/api/Record/GetRecord/Ru/${advertId}`,
      method: 'get'
    }).then(res => {
      return axios({
        url: `/api/Record/GetRecordForView/Ru/${advertId}`,
        method: 'get'
      }).then(response => {
        let data = response.data
        data.advertType = res.data.advertType
        commit('SET_ADVERT_ITEM', response.data)
      })
    })
  },
  GET_COUNTERS({ state }) {
    const lang = state.language
    return axios({
      method: 'GET',
      url: `/api/record/GetMainPageCounters/${lang}`
    }).then(response => {
      return response.data
    })
  },
  INCREASE_NUMBER_OF_VIEWS(ctx, advertId) {
    axios.post(`/api/record/ViewedRecord/${advertId}`)
  },
  UPLOAD_IMAGES(context, media) {
    return axios({
      method: 'post',
      url: 'https://cdn.onoi.kg/api/upload/folder/',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: media
    })
      .then(response => {
        return response.data
      })
      .catch(e => {
        const { data } = e.response
        return { error: true, msg: (data || {}).message }
      })
  }
}
